/** @format */

import React, { useEffect, useState } from "react";

import Page1 from "./Page1";
import Page2 from "./Page2";
import Page3 from "./Page3";
import Page4 from "./Page4";
import Tabs from "../../../components/Tabs";
import ContentTop from "../../../components/ContentTop";

const SirdaryoSahifa = () => {
  const [toggle, setToggle] = useState(3);

  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));

  const [ldate, setLdate] = useState(date);
  const [lmonth, setLmonth] = useState(month);

  useEffect(() => {
    setDate(ldate);
  }, [ldate]);

  useEffect(() => {
    setMonth(lmonth);
  }, [lmonth]);

  const tabs = [
    { title: "Jadval", id: 3, type: "text" },
    { title: "Diagramma", id: 1, type: "text" },
    { title: "Sxema", id: 2, type: "text" },
    { title: "location", id: 4, type: "location" },
  ];

  const pages = (t) => {
    const pageProps = t === 3 ? { month } : { date };
    const components = {
      1: <Page1 {...pageProps} />,
      2: <Page2 {...pageProps} />,
      3: <Page3 {...pageProps} />,
      4: <Page4 {...pageProps} />,
    };
    return components[t] || <Page3 month={month} />;
  };

  return (
    <div className='amudaryo'>
      <ContentTop>
        <ul className='content-top-left'>
          <li>Sirdaryo balansi</li>

          <div>
            <Tabs toggle={toggle} setToggle={setToggle} tabs={tabs} />
          </div>
        </ul>

        <div className='content-top-right'>
          {toggle == 3 ? (
            <input
              type='month'
              className='form-control form-control-sm'
              onChange={(e) => setLmonth(e.target.value)}
              value={lmonth}
            />
          ) : (
            <input
              type='date'
              className='form-control form-control-sm'
              onChange={(e) => setLdate(e.target.value)}
              value={ldate}
            />
          )}
        </div>
      </ContentTop>

      <div className='tabs-content table-box extra-tab-css'>
        <div className='tabs-content-item active'>{pages(toggle)}</div>
      </div>
    </div>
  );
};

export default SirdaryoSahifa;
